











































import Modal from "../../core/Modals/Modal.vue";
import { InterventionApi } from "../../api/InterventionApi";
import { Intervention } from "../../models/Intervention";
import moment from "moment";
import DateInput from "../../core/Forms/DateInput.vue";
import WeekSelector from "../../core/Forms/WeekSelector.vue";
import CheckboxInput from "../../core/Forms/CheckboxInput.vue";
import InputField from "../../core/Forms/InputField.vue";
import { DateUtils } from "../../utils/DateUtils";

export default {
    name: "InterventionReassignDateEdit",
    components: { InputField, CheckboxInput, WeekSelector, DateInput, Modal },
    props: {
        interventions: Array,
    },
    data() {
        return {
            weekMode: false,
            selectedDate: moment().format("DD/MM/YYYY"),
            selectedWeek: moment().week(),
            showModal: true,
            saving: false,
            InterventionApi: new InterventionApi(),
        };
    },
    created() {},
    methods: {
        closeModal: function (): void {
            this.$emit("close-modal");
        },
        saveData: function (): void {
            let self = this;
            let promises = [];

            if (self.saving) {
                return;
            }

            self.saving = true;

            _.forEach(self.interventions, function (interventionData) {
                let intervention = new Intervention(interventionData);
                if (self.weekMode) {
                    let newDate = moment(
                        intervention.date_prevue_intervention,
                        "YYYY-MM-DD"
                    );
                    newDate.week(self.selectedWeek.week);
                    intervention.date_prevue_intervention =
                        newDate.format("YYYY-MM-DD");
                } else {
                    intervention.date_prevue_intervention =
                        DateUtils.dateStrToSql(self.selectedDate);
                }
                let promise = self.InterventionApi.save(intervention).then(
                    function (res) {
                        return res;
                    }
                );
                promises.push(promise);
            });
            Promise.all(promises).then(function () {
                self.closeModal();
            });
        },
    },
};
